import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import IconClose from "../../../Resources/svg/Icons/IconClose";
import IconWarning from "../../../Resources/svg/Icons/IconWarning";
import { modalError } from "../../../Store/simulate/actions";
import { textErrors } from "../../../Utils/aprobaciones/modalesErrors";
import Button from "../../../Components/FormElements/Button";

interface Props {
  className?: string;
  variant?: string;
}
const ModalErrores = ({ className, variant }: Props) => {
  const history = useHistory();

  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const { modalError: modalErrorState, errortext } = useSelector(
    (state: any) => state.simulate.policy
  );

  const handleClose = () => {
    setIsOpen(false);
    dispatch(modalError(false));
    document.body.style.overflow = "auto";
  };

  const handleOpen = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  useEffect(() => {
    if (modalErrorState) {
      handleOpen();
    } else {
      handleClose();
    }
  }, [modalErrorState]);

  const handleErrorModal = () => {
    setIsOpen(false);
    dispatch(modalError(false));
    document.body.style.overflow = "auto";
    history.push("/aprobaciones");
  };

  const textFilter = textErrors.filter((v) => v.code === errortext);
  const { title } = textFilter[0];

  return (
    <div
      className={
        "modal-filtering modal-result is-midle-error" +
        (isOpen ? " is-open" : "") +
        (className ? " " + className : "")
      }
    >
      <div className={"modal-filtering__box"}>
        {!variant && (
          <div className="modal-filtering__close" onClick={handleClose}>
            <IconClose />
          </div>
        )}
        <div className="modal-filtering__body">
          <div className="wrap">
            <div className="modal-filtering__inner">
              <div className="modal-result__icon--warning">
                <IconWarning />
              </div>
              <h2 className="modal-result__title">{title}</h2>
              <div className="modal-result__desc">
                La cotización seguirá en estado <span>pendiente</span> y
                volverás al <span>listado de aprobaciones.</span>
              </div>
              <div className="actions">
                <Button
                  className="actions__continue"
                  onClick={handleErrorModal}
                >
                  Entendido
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalErrores;
